







import { Component, Mixins } from "vue-property-decorator";
import { default as MediaSelectableContentMixin } from "./mixins/MediaSelectableContentMixin.vue";
import { FatalIndicator } from "./common";
import { instanceOfIFixedTextIndicatable } from "../../../../../../domain/format";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentMediaRemover extends Mixins(MediaSelectableContentMixin) {
  get text(): string {
    return instanceOfIFixedTextIndicatable(this.content)
      ? this.content.fixedText
      : "削除";
  }

  onClearSourceClicked() {
    this.clearSource();
  }
}
